import * as THREE from 'three';
import { woodMap, woodNormal } from "../material";
function fromMaterialDTO(dto) {
    const mat = new THREE.MeshStandardMaterial();
    woodMap.wrapS = woodMap.wrapT = THREE.RepeatWrapping;
    woodNormal.wrapS = woodNormal.wrapT = THREE.RepeatWrapping;
    mat.map = woodMap;
    mat.needsUpdate = true; // ← добавь
    if (dto.color !== undefined) {
        mat.color.setHex(dto.color);
    }
    if (dto.opacity !== undefined) {
        mat.opacity = dto.opacity;
        mat.transparent = dto.opacity < 1;
    }
    if (dto.metalness !== undefined) {
        mat.metalness = dto.metalness;
    }
    if (dto.roughness !== undefined) {
        mat.roughness = dto.roughness;
    }
    // Сохраняем оригинальный id чтобы можно было идентифицировать материал
    mat.userData.id = dto.id;
    return mat;
}
function fromVec3DTOToMPos(dto) {
    return [dto.x, dto.y, dto.z];
}
function fromVec3DTOToMRot(dto) {
    return [dto.x, dto.y, dto.z];
}
export function fromRenderStructDTO(dto) {
    console.log(dto);
    return {
        vertices: dto.vertices,
        indices: dto.indices,
        uvs: dto.uvs,
        group: dto.group,
        position: dto.position ? fromVec3DTOToMPos(dto.position) : undefined,
        rotation: dto.rotation ? fromVec3DTOToMRot(dto.rotation) : undefined,
        material: dto.material.map(fromMaterialDTO),
        elements: dto.elements.map(el => ({
            indices: el.indices,
            vertices: el.vertices,
            name: el.name,
            nameGroup: el.nameGroup,
            position: fromVec3DTOToMPos(el.position),
            rotation: fromVec3DTOToMRot(el.rotation),
            uvs: el.uvs,
            material: el.material,
            specId: el.specId,
        })),
        specIds: dto.specIds,
    };
}
export function fromRenderStructDTOArray(dtos) {
    return dtos.map(fromRenderStructDTO);
}
